import MuiBottomNavigation, {
  type BottomNavigationProps,
} from "@mui/material/BottomNavigation";
import MuiBottomNavigationAction, {
  type BottomNavigationActionProps,
} from "@mui/material/BottomNavigationAction";

export type { BottomNavigationProps, BottomNavigationActionProps };

export function BottomNavigation(props: BottomNavigationProps) {
  return <MuiBottomNavigation {...props} />;
}

export function BottomNavigationAction(props: BottomNavigationActionProps) {
  return <MuiBottomNavigationAction {...props} />;
}
